import Card from "./Card";
import TablePaginate from "../table/TablePaginate";
import { CardTablePropsInterface } from './typings';
import { BiRefresh } from "react-icons/bi";

export default function CardTable({ extras,setStatus,status,haveFilter=false, title, columns, loading, datas, pagination, setPagination, tableClassName = "", className = "", extrasClassName = "", loadingExport, handleDownloadExcel }: CardTablePropsInterface) {
  
 const statusOptions = [
  { label: "Rebond", value: "Bounce" },
  { label: "Différé", value: "deferral" },
  { label: "Délivré", value: "delivered" },
  { label: "Livraison", value: "Delivery" },
  { label: "Retard de livraison", value: "DeliveryDelay" },
  { label: "Échec", value: "failed" },
  { label: "Rebond permanent", value: "hard_bounce" },
  { label: "En attente", value: "pending" },
  { label: "Envoyé", value: "sent" },
  { label: "Rebond temporaire", value: "soft_bounce" },
];


    return <>
        <Card className={className} title={title} extras={extras} extrasClassName={extrasClassName}>
            {haveFilter &&
            <div className="flex py-4 w-full px-4  items-end gap-3 ">
                <span className="text-xl font-medium whitespace-nowrap">
                    Filtrer par statut :
                </span>
                 <select value={status} onChange={(e) => setStatus(e.target.value)} className="border rounded px-4 py-2">
                    <option value="">Tous les statuts</option>
                    {statusOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                 </select>
                  <div onSubmit={handleDownloadExcel} className="flex  rounded-md justify-center items-center gap-2 bg-soft-secondary px-4 py-2 cursor-pointer" onClick={handleDownloadExcel}>
                    Télécharger
                    {loadingExport && <BiRefresh className="animate-spin" /> }
                </div>
                  
                

            </div>
            }
            <TablePaginate columns={columns} loading={loading} datas={datas} pagination={pagination} setPagination={setPagination} tableClassName={tableClassName} />
        </Card>
    </>
}
